<div class="row">
    <div class="col-12 col-lg-4 col-sm-6 mb-2">
        <label>{{'assignments.billedAssignments.period' | transloco}}</label>
        <p>{{ period.period }}</p>
    </div>
    <div class="col-12 col-lg-4 col-sm-6 mb-2">
        <label>{{'assignments.billedAssignments.payoutMonth' | transloco}}</label>
        <p>{{ period.payoutMonth }}</p>
    </div>
    <div class="col-12 col-lg-4 col-sm-6 mb-2">
        <label>{{'assignments.billedAssignments.totalSalaryExt' | transloco}}</label>
        <p style="white-space: nowrap;">
            {{'shared.swissFranc' |transloco}} {{ period.totalSalary | number: '1.2-2'}}
        </p>
    </div>
</div>